export default __webpack_public_path__ + "static/media/ChevronRightIcon.b19b0791.svg";